import { ON_FIND_YOUR_REP_POPUP } from '../LocalRep/actions';

import {
    getRepStanceApi,
    completeRepStanceApi
} from '../../utils/repStance/repStanceApi';
import { mapPositionsToReps } from '../../utils/repStance/helpers';

export const REP_STANCE_ACTION_UPDATED = 'REP_STANCE_ACTION_UPDATED';
export const REP_STANCE_COMPLETED = 'REP_STANCE_COMPLETED';
export const REP_STANCE_INITATED = 'REP_STANCE_INITATED';
export const REP_STANCE_LOADING = 'REP_STANCE_LOADING';
export const REP_STANCE_UNAVAILABLE = 'REP_STANCE_UNAVAILABLE';
export const SET_REP_STANCE = 'SET_REP_STANCE';

const popupErrorMessage =
    'To locate your representatives, please enter your US-based address below.';

export const repStanceUpdated = actionIdentifier => dispatch =>
    dispatch({ type: REP_STANCE_ACTION_UPDATED, payload: actionIdentifier });

export const initiateRepStance = actionIdentifier => dispatch =>
    dispatch({ type: REP_STANCE_INITATED, payload: actionIdentifier });

export const completeRepStance = (
    apiRequestData,
    actionCompletedTime,
    actionIdentifier
) => dispatch => {
    return completeRepStanceApi(apiRequestData, actionCompletedTime).then(res => {
        dispatch({
            type: REP_STANCE_COMPLETED,
            payload: {
                ...apiRequestData,
                actionIdentifier,
                counter: res.counter
            }
        });
    });
};

export const getRepStances = (repData, question) => dispatch => {
    dispatch({ type: REP_STANCE_LOADING, payload: true });

    const candidateIds = [];
    repData.forEach(rep => {
        if (rep.voteSmartCandidateId) candidateIds.push(rep.voteSmartCandidateId);
    });

    if (candidateIds.length === 0) {
        dispatch({ type: REP_STANCE_LOADING, payload: false });
        dispatch({
            type: REP_STANCE_UNAVAILABLE,
            payload: {
                bool: true,
                popupErrorMessage
            }
        });
        dispatch({
            type: ON_FIND_YOUR_REP_POPUP,
            payload: true
        });
        return;
    }

    return getRepStanceApi(candidateIds, question)
        .then(repStanceData => {
            dispatch({
                type: SET_REP_STANCE,
                payload: mapPositionsToReps(repStanceData, repData)
            });
            dispatch({ type: REP_STANCE_LOADING, payload: false });
        })
        .catch(() => {
            dispatch({ type: REP_STANCE_LOADING, payload: false });
            dispatch({
                type: REP_STANCE_UNAVAILABLE,
                payload: {
                    bool: true,
                    popupErrorMessage
                }
            });
            dispatch({
                type: ON_FIND_YOUR_REP_POPUP,
                payload: true
            });
        });
};
